/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import OttoChat from './OttoChat';
import OttoIcon from './OttoIcon';

function OttoPill() {
  const [chatVisible, setChatVisible] = useState(false);

  const { paidFlags = [] } = useSelector((state) => state.settings.company);
  const hasAIChatAccess = paidFlags.includes('AI_CHAT');

  // Don't render if company doesn't have AI_CHAT access
  if (!hasAIChatAccess) {
    return null;
  }

  return (
    <>
      <div
        className="otto-pill-container"
        onClick={() => {
          setChatVisible(!chatVisible);
        }}
      >
        <OttoIcon />
        <span className="otto-pill-text">Otto</span>
      </div>
      <OttoChat
        visible={chatVisible}
        onClose={() => setChatVisible(false)}
      />
    </>
  );
}

export default OttoPill;
